// Collapsed-by-default "Why?" disclosure rendered immediately under the
// DecisionValidationBadge. Extracted from DecisionEnginePage.js during
// Phase 1 consolidation — no logic or visual changes.
//
// This component owns local `open` toggle state but holds no app state.
// It is listed as "stateless" per the Phase 1 spec because its state is
// purely view-local (a pure presentational disclosure).
import React, { useState } from 'react';

export const DecisionExplanationDisclosure = ({ explanation, status }) => {
  const [open, setOpen] = useState(false);
  const rules = Array.isArray(explanation?.triggered_rules) ? explanation.triggered_rules : [];
  const summary = (explanation?.summary || '').trim();
  // Hide entirely when there's nothing to explain.
  if (!rules.length && !summary) return null;

  const tone = {
    safe: 'text-emerald-700 dark:text-emerald-400',
    caution: 'text-amber-700 dark:text-amber-400',
    conflict: 'text-red-700 dark:text-red-400',
  }[status] || 'text-gray-600 dark:text-gray-400';

  return (
    <div className="text-[11px]" data-testid="decision-explanation">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className={`underline-offset-2 hover:underline focus:outline-none focus:underline transition-colors ${tone}`}
        data-testid="decision-explanation-toggle"
      >
        {open ? 'Hide why' : 'Why?'}
      </button>
      {open && (
        <div
          className="mt-1.5 ml-1 space-y-1"
          data-testid="decision-explanation-content"
        >
          {rules.length > 0 && (
            <ul
              className="list-disc list-inside space-y-0.5 text-gray-700 dark:text-gray-300"
              data-testid="decision-explanation-rules"
            >
              {rules.map((r, i) => (
                <li key={i} data-testid={`decision-explanation-rule-${i}`}>{r}</li>
              ))}
            </ul>
          )}
          {summary && (
            <p
              className="text-gray-600 dark:text-gray-400 italic"
              data-testid="decision-explanation-summary"
            >
              {summary}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
